import Modal from '@/components/Modal'
import { Card, Text } from '@conexasaude/conexa-hero'
import useStyles from './styles'
import { Icon } from '@conexasaude/iconography/icons'
import { useBiometryStart } from '../../mutations'
import Biometry from '../../classes/Biometry'
import { setCache } from '@/utils/cache'

export const BiometryStartModal = () => {
  const styles = useStyles()
  const startBiometry = useBiometryStart()

  const handleStartBiometry = () => {
    const currentLocation = window.location.href
    const biometryData = Biometry.getBiometryData()

    const callbackUrl = new URL(biometryData?.callbackRoute, currentLocation)
    callbackUrl.searchParams.set('fromBiometry', 'true')

    startBiometry.mutate(
      {
        callbackUri: callbackUrl.toString(),
        captcha: biometryData?.captcha,
        cpf: biometryData?.cpf,
        withoutLogin: biometryData?.biometryFlow === 'activation',
        clinicId: biometryData?.clinicId,
        action: biometryData?.action,
      },
      {
        onSuccess: data => {
          setCache('biometryProcessId', data.processId)
          window.open(data.url, '_self')
        },
      },
    )
  }

  return (
    <Modal
      id="BIOMETRY_MODAL"
      title="Ambiente seguro"
      iconTitle="information"
      primaryAction={handleStartBiometry}
      busyPrimaryAction={startBiometry.isLoading}
      primaryActionLabel="Continuar"
      customHeader={
        <div css={styles.header}>
          <Icon name="lock" size="small" />

          <Text variant="headingSmall">Ambiente seguro</Text>
        </div>
      }
    >
      <div css={styles.root}>
        <Text>
          Para continuar, precisamos validar a sua identidade através do
          cadastro by Unico
        </Text>

        <Text variant="paragraphSmall">Sobre a validação</Text>

        <Card.Root>
          <Card.Section>
            <div css={styles.cardWrapper}>
              <Icon name="face-id" />
              <div css={styles.cardContainer}>
                <Text variant="subheading">Identidade</Text>

                <Text variant="paragraphSmall">
                  A Unico identificará você usando a sua biometria.{' '}
                </Text>
              </div>
            </div>
          </Card.Section>
        </Card.Root>
        <Card.Root>
          <Card.Section>
            <div css={styles.cardWrapper}>
              <Icon name="camera" />
              <div css={styles.cardContainer}>
                <Text variant="subheading">Celular com câmera</Text>

                <Text variant="paragraphSmall">
                  Você precisa de um celular com câmera para validar a sua
                  identidade.
                </Text>
              </div>
            </div>
          </Card.Section>
        </Card.Root>
      </div>
    </Modal>
  )
}
